import { CreditsSummaryTotalEntity } from "../entities/CreditSummaryEntity";
import { CreditsRepository } from "../repositories/CreditsRepository";

export class GetCustomerCreditsSummaryUseCase {
  constructor(private repository: CreditsRepository) {}

  async execute(autoRefresh?: boolean): Promise<CreditsSummaryTotalEntity> {
    return await this.repository.getCustomerCreditsSummary(autoRefresh);
  }
}

